export const VideoPageTemplate = {
    slots: ['SlbVideoDetailSlot'],
};
